import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Brush,
} from "recharts";

export default function TankChart({ data }) {
  const getOrdinalSuffix = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  // Custom date formatting function
  const formatDate = (date) => {
    const d = new Date(date);
    const day = getOrdinalSuffix(d.getDate());
    const hour = d.getHours();
    const hourFormatted = hour % 12 || 12; // Convert 24h to 12h format
    const ampm = hour < 12 ? "am" : "pm";
    return `${day} ${hourFormatted}${ampm}`;
  };

  const formattedData = data.map((d) => {
    return {
      date: new Date(d.date_added).getTime(),
      waterTemp: d.data.temperature,
    };
  });

  // Assuming formattedData is already sorted by date
  // Guard against small arrays so we don't divide by zero (which leads to NaN)
  const tickInterval = Math.max(1, Math.floor(formattedData.length / 6)); // at least 1
  // ticks must be numeric timestamps because XAxis is type="number"
  const ticks = formattedData
    .filter((_, index) => index % tickInterval === 0)
    .map((d) => d.date);

  // If the last date is not included, add it manually (number)
  if (formattedData.length > 0) {
    const lastDate = formattedData[formattedData.length - 1].date
    if (ticks[ticks.length - 1] !== lastDate) {
      ticks.push(lastDate)
    }
  }

  return (
    <div style={{ height: 500 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={formattedData}
          margin={{
            top: 10,
            right: 0,
            left: 0,
            bottom: 10,
          }}
        >
          <CartesianGrid strokeDasharray="7 7" xAxisId="bottom" yAxisId="right" />
          <XAxis
            dataKey="date"
            type="number"
            domain={["auto", "auto"]}
            scale="time"
            tickFormatter={(date) => formatDate(date)}
            ticks={ticks}
          />
          <YAxis yAxisId="right" id="right" domain={[15, 22]} />
          <Tooltip labelFormatter={(label) => formatDate(label)} />
          <Legend />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="waterTemp"
            stroke="#82ca9d"
          />
          <Brush dataKey="date" height={30} stroke="#8884d8" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
